/* @flow */

import * as React from 'react';

import {reduxForm} from 'redux-form';
import type {FormProps} from 'redux-form/lib/types.js.flow';

import {colors} from 'shells/colors';
import {StackLegacy} from 'shells/layout';
import {Link} from 'shells/link';
import {ProgressBar} from 'shells/progress-bar';
import {Body} from 'shells/typography';

import {TINY_INTRO_REDUX_FORM} from '../constants';

import './final-page.module.css';

type OwnProps = {|
    isProvisioningComplete: boolean,
    accountProvisionedErrorMessage: ?string,
|};

type Props = {...OwnProps, ...$Exact<FormProps>};

export function FinalPageComponent(props: Props) {
    const [progress, setProgress] = React.useState<number>(0.1);

    if (props.isProvisioningComplete && progress >= 0.9) {
        props.handleSubmit();
    }

    React.useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prevProgress) => {
                const newProgress = prevProgress + 0.02;

                return newProgress > 0.95 ? 0.95 : newProgress;
            });
        }, 100);

        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <div styleName='progress-bar-container'>
                <ProgressBar
                    height={8}
                    color={colors.blueDk}
                    percentComplete={progress}
                    backgroundColor={colors.blueBg}
                />
            </div>
            <div styleName='background-image'>
                {props.accountProvisionedErrorMessage ? (
                    <StackLegacy spacing={16} alignCenter={true}>
                        <img
                            alt='error'
                            src='/include/images/lead/entity-permissions.svg'
                            className='full-width full-height'
                        />
                        <Body size='xlarge' isBold={true} color='dark'>
                            Something went wrong setting up your Nutshell account.
                        </Body>
                        <div styleName='subtitle'>
                            <Body size='large'>
                                This shouldn’t happen! Please contact our support team at <br />
                            </Body>
                            <Link href='mailto:support@nutshell.com' variant='primary' size='big'>
                                support@nutshell.com
                            </Link>
                            <Body size='large'>, or give us a call at 888-336-8808.</Body>
                        </div>
                    </StackLegacy>
                ) : (
                    <StackLegacy spacing={24} alignCenter={true}>
                        <img alt='success' src='/include/images/auth/finish.svg' />
                        <Body size='xlarge' isBold={true} color='dark'>
                            Nicely done!
                        </Body>
                        <Body size='large'>
                            Hang tight for few seconds while we finish setting up your account.
                        </Body>
                    </StackLegacy>
                )}
            </div>
        </>
    );
}

export const FinalPage = reduxForm({
    form: TINY_INTRO_REDUX_FORM,
    destroyOnUnmount: false,
})(FinalPageComponent);
